import { Fragment } from "react";
import "../legal/css/legal.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Banner from "../../images/servicio/mision-vision/banner.webp";
import IconoCliente from "../../images/servicio/mision-vision/icono_valor_cliente.webp";
import IconoReto from "../../images/servicio/mision-vision/icono_valor_reto.webp";
import IconoColaboracion from "../../images/servicio/mision-vision/icono_valor_colaboracion.webp";
import IconoGente from "../../images/servicio/mision-vision/icono_valor_gente.webp";
import IconoGlobalidad from "../../images/servicio/mision-vision/icono_valor_globalidad.webp";
import Mision from "../../images/servicio/mision-vision/mision.webp";
import Vision from "../../images/servicio/mision-vision/vision.webp";
import BannerMobile from "../../images/servicio/mision-vision/banner-mobile.webp";
import Image from "react-bootstrap/Image";

function InfoRescueSheets() {
    return (
        <Fragment>
            <link rel="preload" href="../public/fonts/HyundaiSansHead-Regular.otf" as="font" type="font/otf" crossOrigin/>
            <link rel="preload" href="../public/fonts/HyundaiSansHead-Bold.woff2" as="font" type="font/woff2" crossOrigin/>
            <link rel="preload" href="../public/fonts/HyundaiSansHead-Light.otf" as="font" type="font/otf" crossOrigin/>
            <link rel="preload" href="../public/fonts/HyundaiSansHead-Medium.otf" as="font" type="font/otf" crossOrigin/>
            <link rel="preload" href="../public/fonts/HyundaiSansHeadOffice-Regular.ttf" as="font" type="font/otf" crossOrigin/>
            <link rel="preload" href="../public/fonts/HyundaiSansText-Regular.otf" as="font" type="font/otf" crossOrigin/>
            <link rel="preload" as="image" href={Banner} />
            <link rel="preload" as="image" href={IconoCliente} />
            <link rel="preload" as="image" href={IconoReto} />
            <link rel="preload" as="image" href={IconoColaboracion} />
            <link rel="preload" as="image" href={IconoGente} />
            <link rel="preload" as="image" href={IconoGlobalidad} />
            <Container fluid={true} className="banner-legal">
                <Row>
                    <Col md={12} className="px-0">
                        <Card>
                            <Image
                                width="2560px" height="635px"
                                src={Banner}
                                alt="Hyundai Banner"
                                className="d-none d-sm-block banner"
                                fluid
                                loading="lazy"
                            />
                            <Image
                                src={BannerMobile}
                                alt="Hyundai Banner"
                                className="d-block d-sm-none"
                                fluid
                            />
                            <Card.ImgOverlay className="d-flex">
                                <Card.Title className="bg-banner-legal w-100 d-flex align-items-center">
                                    <div className="mx-auto w-100">
                                        <h1 className="legal-banner-titulo">
                                            Filosofía Corporativa
                                        </h1>
                                        <br />
                                        <h2 className="legal-banner-subtitulo">Hyundai Ecuador</h2>
                                    </div>
                                </Card.Title>
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Container className="py-4 py-md-5 fixed-height">
                <Row className="padding-top">
                    <Col md={6} className="text-center padding-top">
                        <h2 className="model-title">Misión</h2>
                        <Image width="640" height="300" src={Mision} alt="Accent Calidad" className="img-mision" fluid/>
                        <br></br>
                        <p className="px-3 px-md-0 padding-top">
                            Garantizar la satifacción de las personas, superando expectativas, y a lo largo de los próximos 5 años ser reconocidos por nuestros altos estándares de calidad.
                        </p>
                    </Col>
                    <Col md={6} className="text-center padding-top">
                        <h2 className="model-title">Visión</h2>
                        <Image width="640" height="300" src={Vision} alt="Accent Calidad" className="img-mision" fluid/>
                        <p className="px-3 px-md-0 padding-top">
                            Recuperar el posicionamientode la marca, afianzando nuestro legado y tradición en el mercado con el fortalecimiento de la calidad de nuestros servicios y equipos de alto desempeño.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container className="py-4 py-md-5">
                <Row>
                    <Col md={12} className="text-center">
                        <h2 className="model-title">Principios Organizacionales</h2>
                    </Col>
                </Row>
            </Container>
            <Container className="legales">
                <Row>
                    <Col md={12}>
                        <Container className="pb-3">
                            <Row>
                                <Col md={6} className="my-auto order-2 order-md-1">
                                    <center>
                                        <Image width="100" height="60" src={IconoCliente} alt="Accent Expresivo" className="ico-principios" />
                                        <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                                            Enfoque al cliente
                                        </h3>
                                        <p className="specs-text2 px-3 px-md-0 d-block d-sm-none">
                                            Concebimos a nuestros clientes como nuestro principal activo, nuestro principal patrimonio, nuestra razón de existir.
                                        </p>
                                        <p className="specs-text2 px-3 px-md-0 d-block d-sm-none">
                                            Brindamos un servicio de excelencia, procurando siempre una experiencia agradable y única.
                                            Cultivamos relaciones a largo plazo, basados en confianza y honestidad, con ánimo de ganancia mutua, que asegure el éxito de las dos partes.
                                            Buscamos la admiración y preferencia de nuestros clientes, realizando todos los esfuerzos para conquistar su felicidad.
                                        </p>
                                    </center>
                                </Col>
                                <Col md={6} className="my-auto order-2 order-md-1">
                                    <center>
                                        <Image width="100" height="60" src={IconoReto} alt="Accent Expresivo" className="ico-principios" />
                                        <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                                            Reconocimiento a los colaboradores
                                        </h3>
                                    </center>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} className="my-auto order-2 order-md-1">
                                    <p className="specs-text2 px-3 px-md-0 d-none d-sm-block">
                                        Concebimos a nuestros clientes como nuestro principal activo, nuestro principal patrimonio, nuestra razón de existir.
                                    </p>
                                    <p className="specs-text2 px-3 px-md-0 d-none d-sm-block">
                                        Brindamos un servicio de excelencia, procurando siempre una experiencia agradable y única.
                                        Cultivamos relaciones a largo plazo, basados en confianza y honestidad, con ánimo de ganancia mutua, que asegure el éxito de las dos partes.
                                        Buscamos la admiración y preferencia de nuestros clientes, realizando todos los esfuerzos para conquistar su felicidad.
                                    </p>
                                </Col>
                                <Col md={6} className="order-1 order-md-2">
                                    <p className="specs-text2 px-3 px-md-0">
                                        Reconocemos la excelencia en el desempeño de nuestros colaboradores a través de incentivos, capacitación y/o promoción de cargos.
                                    </p>
                                    <p className="specs-text2 px-3 px-md-0">
                                        Promovemos una cultura de mérito, enfocada al incentivo en función de logro de objetivos.
                                        Impulsamos que los miembros de nuestro equipo destaquen por actitud ganadora, positiva, alegre y honesta frente a la vida.
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} className="my-auto order-2 order-md-1">
                                    <center>
                                        <Image width="100" height="60" src={IconoColaboracion} alt="Accent Expresivo" className="ico-principios" />
                                        <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                                            Comportamiento ético
                                        </h3>
                                        <p className="specs-text2 px-3 px-md-0 d-block d-sm-none">
                                            Nuestro actuar diario se enmarca en el estricto cumplimiento del Código de ética por parte de nuestros colaboradores.
                                        </p>
                                        <p className="specs-text2 px-3 px-md-0 d-block d-sm-none">
                                            Promovemos la integridad, transparencia, credibilidad y honorabilidad como los atributos más valorados en nuestro equipo de trabajo.
                                        </p>
                                        <p className="specs-text2 px-3 px-md-0 d-block d-sm-none">
                                            Formamos un equipo responsable y comprometido con las funciones y/o bienes encomendados y esperamos su máximo compromiso sobre el cuidado de ellos.
                                        </p>
                                        <p className="specs-text2 px-3 px-md-0 d-block d-sm-none">
                                            Mantenemos como premisa el respeto, la formalidad, y la cordialidad en las relaciones interpersonales, tanto hacia e interior de la organización como hacia clientes, proveedores y más grupos de interés.
                                        </p>
                                        <p className="specs-text2 px-3 px-md-0 d-block d-sm-none">
                                            Somos gratos reconociendo el aporte de cada miembro del equipo; su esfuerzo, su dedicación a la consecución de objetivos.
                                        </p>
                                        <p className="specs-text2 px-3 px-md-0 d-block d-sm-none">
                                            Reconocemos que la cultura organizacional se construye a través del comportamiento individual de cada colaborador y por eso incentivamos el aporte de cada miembro desde sus valores particulares.
                                        </p>
                                    </center>
                                </Col>
                                <Col md={6} className="my-auto order-2 order-md-1">
                                    <center>
                                        <Image width="100" height="60" src={IconoGente} alt="Accent Expresivo" className="ico-principios" />
                                        <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                                            Orgullo por nuestra empresa y marcas
                                        </h3>
                                    </center>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} className="my-auto order-2 order-md-1">
                                    <p className="specs-text2 px-3 px-md-0 d-none d-sm-block">
                                        Nuestro actuar diario se enmarca en el estricto cumplimiento del Código de ética por parte de nuestros colaboradores.
                                    </p>
                                    <p className="specs-text2 px-3 px-md-0 d-none d-sm-block">
                                        Promovemos la integridad, transparencia, credibilidad y honorabilidad como los atributos más valorados en nuestro equipo de trabajo.
                                    </p>
                                    <p className="specs-text2 px-3 px-md-0 d-none d-sm-block">
                                        Formamos un equipo responsable y comprometido con las funciones y/o bienes encomendados y esperamos su máximo compromiso sobre el cuidado de ellos.
                                    </p>
                                    <p className="specs-text2 px-3 px-md-0 d-none d-sm-block">
                                        Mantenemos como premisa el respeto, la formalidad, y la cordialidad en las relaciones interpersonales, tanto hacia e interior de la organización como hacia clientes, proveedores y más grupos de interés.
                                    </p>
                                    <p className="specs-text2 px-3 px-md-0 d-none d-sm-block">
                                        Somos gratos reconociendo el aporte de cada miembro del equipo; su esfuerzo, su dedicación a la consecución de objetivos.
                                    </p>
                                    <p className="specs-text2 px-3 px-md-0 d-none d-sm-block">
                                        Reconocemos que la cultura organizacional se construye a través del comportamiento individual de cada colaborador y por eso incentivamos el aporte de cada miembro desde sus valores particulares.
                                    </p>
                                </Col>
                                <Col md={6} className="order-1 order-md-2">
                                    <p className="specs-text2 px-3 px-md-0">
                                        Representamos con excelencia y orgullo a la empresa y marcas con las que trabajamos; consientes del valioso aporte que representan para la economía y desarrollo del país, para cada comunidad local donde nos desempeñamos y para las familias que impactamos directamente a través del empleo.
                                    </p>
                                    <p className="specs-text2 px-3 px-md-0">
                                        Cuidamos de mantener en alto la reputación de nuestras organizaciones conscientes	 de su valor es un activo intangible e inigualable construido a lo largo de los años.
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} className="my-auto order-2 order-md-1">
                                    <center>
                                        <Image width="100" height="60" src={IconoGlobalidad} alt="Accent Expresivo" className="ico-principios" />
                                        <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                                            Agregar valor a la empresa
                                        </h3>
                                    </center>
                                    <p className="specs-text2 px-3 px-md-0">
                                        La mejor forma de agregar valor a la empresa es a través de nuestro compromiso en el cumplimiento de los objetivos, cultura, normativa interna y externa, además de la búsqueda continua de la excelencia a través de la mejora de la productividad, de la eficiencia en los procesos, y la optimización de la rentabilidad.
                                    </p>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>
            <br></br>
            <br></br>
        </Fragment>
    );
}
export default InfoRescueSheets;